import React, { useEffect, useState } from 'react';

// Mosan WebView return URL landing page. The backend currently issues
// the redirect against the customer marketplace domain
// (emercadohub.com/BackToApp), so this voucher-game route is a
// defense-in-depth fallback for any future config where Mosan returns
// here directly, or for shared/copy-pasted URLs that hit the wrong host.
//
// Mosan should intercept via path marker BEFORE the WebView completes
// the load — under normal conditions the page never paints. We render a
// neutral spinner so a brief race never shows a 404 or blank screen.
const BackToApp: React.FC = () => {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowFallback(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="text-center max-w-sm">
        <div className="inline-block w-12 h-12 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mb-6" />
        <h1 className="text-lg font-semibold text-gray-900 mb-2">
          Returning to Mosan
        </h1>
        <p className="text-sm text-gray-600">
          Please wait while Mosan opens the payment screen.
        </p>
        {showFallback && (
          <p className="mt-6 text-xs text-gray-500 leading-relaxed">
            If the payment screen does not appear, open this order from
            inside the Mosan app to continue payment.
          </p>
        )}
      </div>
    </div>
  );
};

export default BackToApp;
